import {
  HotProbsMarketsOutcomesMapItem,
  selectHotProbsMarkets
} from 'astra-core/containers/CommonDataProvider'
import React, { FC } from 'react'
import { Event } from 'betweb-openapi-axios'
import { groupHotProbabilityByOutcomeId } from 'astra-core/utils/events/hotProbabilities/groupHotProbabilityByOutcomeId'

import { useAppSelector } from 'store'

import { EventRowCoefficientV2 } from '../EventRowCoefficient/EventRowCoefficientV2'

export const CoefficientsListV2: FC<{
  outcomeTypes?: HotProbsMarketsOutcomesMapItem[]
  event: Event
}> = ({ outcomeTypes, event }) => {
  const hotProbsMarkets = useAppSelector(selectHotProbsMarkets)
  const hotProbs = groupHotProbabilityByOutcomeId(event, hotProbsMarkets)

  return (
    <>
      {outcomeTypes?.map((coefficientData) => (
        <EventRowCoefficientV2
          {...coefficientData}
          event={event}
          hotProbs={hotProbs}
          key={coefficientData.outcomeTypesName[0]}
        />
      ))}
    </>
  )
}
